/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Chip } from '@mui/material';
import {
  destacarVencimento,
  obterTextoVencimento,
  shouldShowExpirationChip,
} from '../../Nsirs/utils';
import { parseFilaVencimentoMoment } from './constants';
import { metadataChipSx } from './metadataChipSx';

const FilaNsirMetaChips = ({ item }) => {
  if (!item) return null;

  const hoje = moment();
  const dataVencimento = parseFilaVencimentoMoment(item.vencimento);
  const showVencimento = dataVencimento && shouldShowExpirationChip({
    dataConclusao: item.dataConclusao,
    status: item.status,
  });
  // Fila /me/fila envia adereMonth (MM/YYYY) sem necessariamente possuiAdere
  const showAdere = Boolean(item.adereMonth);

  if (!showAdere && !showVencimento) return null;

  return (
    <>
      {showAdere && (
        <Chip
          label={`Adere ${item.adereMonth}`}
          size="small"
          variant="outlined"
          sx={metadataChipSx}
          aria-label={item.adereMonth}
        />
      )}
      {showVencimento && (
        <Chip
          variant="outlined"
          size="small"
          label={obterTextoVencimento(dataVencimento, hoje)}
          style={destacarVencimento(dataVencimento, hoje)}
          sx={{ fontWeight: 600 }}
        />
      )}
    </>
  );
};

FilaNsirMetaChips.propTypes = {
  item: PropTypes.shape({
    adereMonth: PropTypes.string,
    vencimento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataConclusao: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
  }),
};

FilaNsirMetaChips.defaultProps = {
  item: null,
};

export default FilaNsirMetaChips;
